<template>
    <div>
        <b-dropdown-form style="width: 20rem;">
            <b-input-group @submit.stop.prevent>
                <b-form-input ref="trackingNumber" v-model="tracking" placeholder="Tracking number"></b-form-input>
                <b-input-group-append>
                    <b-button :disabled="!tracking" variant="primary" size="sm" @click="addTracking">Add</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-dropdown-form>
    </div>
</template>

<script>
    export default {
        name: "Shipment",
        mounted() {
            this.$nextTick(() => {
                this.$refs.trackingNumber.$el.focus();
            });
        },
        data() {
            return {
                tracking: null,
            }
        },
        methods: {
            addTracking() {
                this.$emit('addTracking', this.tracking);
                this.tracking = null;
            },
        }
    }
</script>

<style scoped>

</style>